// extracted by mini-css-extract-plugin
module.exports = {"mousescroll":"mousescroll_mousescroll__n7B63","nudgeMouse":"mousescroll_nudgeMouse__DIUn1","trackBallSlide":"mousescroll_trackBallSlide__bBGZ5"};